import { render, staticRenderFns } from "./CreatePollModal.vue?vue&type=template&id=6b1bc53c&scoped=true&"
import script from "./CreatePollModal.vue?vue&type=script&lang=ts&"
export * from "./CreatePollModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePollModal.vue?vue&type=style&index=0&id=6b1bc53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1bc53c",
  null
  
)

export default component.exports